/**
 * Taken from openlayers styles
 */
export const SCALE_LINE_CLASSES = `            
<style type="text/css" >
  <![CDATA[
      .ol-scale-line {
          border-radius: 4px; 
          background: rgba(0, 60, 136, 0.3); 
          padding: 2px
      }
      .ol-scale-line-inner {
          border: 1px solid #eee; 
          border-top: none; 
          color #eee; 
          font-size: 10px; 
          text-align: center; 
          margin: 1px;
      }
  ]]>
</style>`;
export const SCALE_BAR_CLASSES = `            
<style type="text/css" >
  <![CDATA[
      .ol-scale-bar {
      position: absolute;
      bottom: 8px;
      left: 8px;
      }
      .ol-scale-step-marker {
        width: 1px;
        height: 15px;
        background-color: #000000;
        float: right;
        z-index: 10;
      }
      .ol-scale-step-text {
        position: absolute;
        bottom: -5px;
        font-size: 12px;
        z-index: 11;
        color: #000000;
        text-shadow: -2px 0 #FFFFFF, 0 2px #FFFFFF, 2px 0 #FFFFFF, 0 -2px #FFFFFF;
      }
      .ol-scale-text {
        position: absolute;
        font-size: 14px;
        text-align: center;
        bottom: 25px;
        color: #000000;
        text-shadow: -2px 0 #FFFFFF, 0 2px #FFFFFF, 2px 0 #FFFFFF, 0 -2px #FFFFFF;
      }
      .ol-scale-singlebar {
        position: relative;
        height: 10px;
        z-index: 9;
        box-sizing: border-box;
        border: 1px solid black;
      }
  ]]>
</style>`;
